import React from "react";
import GeneralTable from "../../components/Table/GeneralTable";
import { useTranslation } from "react-i18next";

export default function EquipmentType() {
    const { t } = useTranslation("translation");

    return (
        <div>
            <GeneralTable
                id="et_gt"
                table="EquipmentType"
                resourcePath="GetDetailedList"
                title={t("EquipmentType")}
                search={t("SearchEquipmentType")}
            />
        </div>
    );
}
